import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import UserRoles from "../../constants/UserRoles";
import {Button} from "reactstrap";
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import CheckBox from "@material-ui/icons/CheckBox";
import {confirmAlert} from "react-confirm-alert";

class AuthCodes extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Auth_Codes._name, API.RequestType.READ_ALL);
		super(props, model);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns =[
			{
				Header: "Date Created",
				id: "created",
				accessor: obj => (moment(obj.created).local().format('MM/DD/YYYY h:mm A'))
			},
			{
				Header: "Engineer",
				id:"user",
				accessor: obj => obj.engineer_name,
			},
			{
				Header: "Verified",
				id:"verified",
				accessor: obj => obj.verified ? 'Verified' : 'Not Verified',
			}
		]

		if (this.props.rootState.roles.some(role => [UserRoles.Admin].includes(role))) {
			columns.push({
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							{props.original.verified === false ?
								<Button color="warning" size={"sm"} block={true} onClick={async () => {
									confirmAlert({
										title: 'Confirm Approval',
										message:"Are you sure you want to manually verify this engineer's number?",
										buttons: [
											{
												label: 'Yes',
												color: 'danger',
												onClick: async () => {
													let model = new API.BuildClass(Types.Auth_Codes._name, API.RequestType.UPDATE);
													model.object = props.original;
													model.object.verified = true;
													try {
														await model.submit(null, 'POST')
														this.reloadTable();
													} catch (error) {
													}
												}
											},
											{
												label: 'No',
												onClick: () => {
												}
											}
										]
									});
								}}>
									<PriorityHigh fontSize='small'/></Button>
								:	<Button color="primary" size={"sm"} block={true}> <CheckBox fontSize={'small'}/></Button>
							}
						</span>
					);
				}
			})
		}
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Alerts')}
							{this.renderHeaderRight("Alerts",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: true,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(AuthCodes);